import { v3 } from "backoffice-api"

export const getNotifications = async (
  params: { "page[number]"?: number } = {}
) => {
  return await v3.getNotifications({ "page[size]": 20, ...params })
}
